import { apiUrl } from '@/constants';
import axios from 'axios';

const state = {
  staffs: [],

};

const mutations = {

  SET_STAFFS(state, staffs) {
    state.staffs = staffs
  },
  ADD_STAFF(){
    
  }
};

const actions = {

  async addStaff({ commit }, staff) {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${apiUrl}/staffs`, staff, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      commit('ADD_STAFF', response.data);
    } catch (error) {
      console.error('Error creating staff:', error);
    }
  },

  async fetchStaffs({ commit }) {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${apiUrl}/staffs`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      commit('SET_STAFFS', response.data);
    } catch (error) {
      console.error('Error fetching items:', error);
    }
  },

};

const getters = {

};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
